if (checkMobileDevice()) {
  executeAfterDelay(30);
} else {
  executeAfterDelay(30);
}

function executeAfterDelay(seconds) {
  setTimeout(function () {
    const eventData = sessionStorage.getItem("events");

    if (eventData) {
      try {
        const parsedData = JSON.parse(eventData);

        const hasOverlayOpened = "OverlayOpened" in parsedData;
        const hasDynamicFormSubmit = "dynamic_form_submit" in parsedData;

        if (!hasOverlayOpened && !hasDynamicFormSubmit) {
          triggerKosOverlayToOpen();
        }
      } catch (e) {
        // parsing error
      }
    } else {
      triggerKosOverlayToOpen();
    }
  }, seconds * 1000);
}

function triggerKosOverlayToOpen() {
  const openBtn = document.querySelector("#myBtn");
  if (openBtn) {
    openBtn.click();
  }
}

function checkMobileDevice() {
  return window.innerWidth <= 768;
}
